import React from 'react';
import TrainingDetail from './TrainingDetail';
import trainingData from '../data/trainingData';

const Training = () => {
  return (
    <main className="page training-page">
      {/* Hero / Intro */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Training</h1>
          <p className="page-subtitle">
            Hands-on, industry-relevant courses designed to upskill teams and accelerate delivery.
            Browse all courses below.
          </p>
        </div>
      </section>

      {/* List / Accordion */}
      <section className="page-body">
        <div className="container">
          <TrainingDetail trainingData={trainingData} />
        </div>
      </section>
    </main>
  );
};

export default Training;
